import gql from 'graphql-tag'
import { eventResultFragment } from '~/graphql/fragments'

export const GET_TRENDING_EVENTS = gql`
  query getTrendingEvents($countryCode: CountryCode) {
    nearby(countryCode: $countryCode) {
      trendingEvents(first: 5) {
        ...eventResult
      }
    }
  }
  ${eventResultFragment}
`
